import api from './api';

/** Download or preview a FileNode through the authenticated API (works when /uploads is not proxied). */
export async function openFileNode(node, { preview = false } = {}) {
    if (!node?._id || node.type !== 'file') return;

    const res = await api.get(`/files/${node._id}/download`, {
        responseType: 'blob',
        params: preview ? { inline: 1 } : undefined,
    });

    const url = URL.createObjectURL(res.data);
    if (preview) {
        window.open(url, '_blank', 'noopener,noreferrer');
        setTimeout(() => URL.revokeObjectURL(url), 120_000);
    } else {
        const a = document.createElement('a');
        a.href = url;
        a.download = node.name || 'download';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    }

    api.post(`/files/${node._id}/tick`).catch(() => {});
}
